/** scroll_speed 1–10 från admin → pixlar per sekund i rullistan */
export function clampBannerScrollSpeed(raw) {
  const n = Number(raw);
  if (!Number.isFinite(n)) return 3;
  return Math.min(10, Math.max(1, Math.round(n)));
}

export function bannerPixelsPerSecond(scrollSpeed) {
  const s = clampBannerScrollSpeed(scrollSpeed);
  /* 1 ≈ 11 px/s (långsam), 5 ≈ 31 px/s, 10 ≈ 56 px/s */
  return 6 + s * 5;
}

export function bannerScrollSpeedLabel(scrollSpeed) {
  const s = clampBannerScrollSpeed(scrollSpeed);
  if (s <= 2) return 'Mycket långsam';
  if (s <= 4) return 'Långsam';
  if (s <= 6) return 'Normal';
  if (s <= 8) return 'Snabb';
  return 'Mycket snabb';
}

export function bannerTextTickerDurationSec(scrollSpeed) {
  const s = clampBannerScrollSpeed(scrollSpeed);
  return 90 - s * 5;
}
